import React from 'react';
import Bear, { Patrol } from './Bear';
import BearCards, { useBearEgg } from './BearCards';

// The title of a page, with an optional line under it and actions on the right. bear: the head (see Bear.js) that stands beside the title; patrol: all five.
export default function PageHeader({ title, subtitle, actions, bear, patrol }) {
  const egg = useBearEgg();
  return (
    <div className="page-head">
      <div className="page-title">
        {bear && <Bear name={bear} size={52} className="page-bear" onClick={egg.onClick} />}
        <div>
          <h1>{title}</h1>
          {subtitle && <div className="sub">{subtitle}</div>}
        </div>
      </div>
      {patrol && <Patrol size={46} />}
      {actions && <div className="page-actions">{actions}</div>}
      {egg.open && <BearCards featured={bear} onClose={egg.close} />}
    </div>
  );
}
